export default {
  youtube: 'https://unpkg.com/@presenta/block-youtube',
  emoji: 'https://unpkg.com/@presenta/block-emoji',
  //qrcode: 'https://unpkg.com/@presenta/block-qrcode',
  barcode: 'https://unpkg.com/@presenta/block-barcode',
  tableau: 'https://unpkg.com/@presenta/block-tableau',
  chartjs: 'https://unpkg.com/@presenta/block-chartjs'
}
